export const APP_NAME = 'CRM7';
export const APP_VERSION = '1.4';

export const SITE_URL = 'https://www.crm7.ru';
export const SITE_LABEL = 'www.crm7.ru';

export const LICENSE_TYPE = 'MIT';
export const LICENSE_HOLDER = 'CRM7 (crm7.ru)';
export const LICENSE_YEAR = 2026;
export const LICENSE_URL = 'https://opensource.org/license/mit';

export const CONTACTS: { label: string; value: string; href?: string }[] = [
  { label: 'Контактное лицо', value: 'Литвинов Антон Александрович' },
  { label: 'Телефон', value: '+79380264903', href: 'tel:+79380264903' },
  { label: 'E-mail', value: 'siteix@yandex.ru', href: 'mailto:siteix@yandex.ru' }
];
